const firebaseConfig = {
  apiKey: "AIzaSyB4BpfXSz43tBdiJx-pwpzFbzUCtbtKD6o",
  authDomain: "shohoz-sebha.firebaseapp.com",
  projectId: "shohoz-sebha",
  storageBucket: "shohoz-sebha.appspot.com",
  messagingSenderId: "63488225649",
  appId: "1:63488225649:web:363b0fb1a5516c847706d0"
};
  export default firebaseConfig;